/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignedUrlRequest
 */
export interface SignedUrlRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SignedUrlRequest
     */
    paths: Array<string>;
}

/**
 * Check if a given object implements the SignedUrlRequest interface.
 */
export function instanceOfSignedUrlRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paths" in value;

    return isInstance;
}

export function SignedUrlRequestFromJSON(json: any): SignedUrlRequest {
    return SignedUrlRequestFromJSONTyped(json, false);
}

export function SignedUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignedUrlRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paths': json['paths'],
    };
}

export function SignedUrlRequestToJSON(value?: SignedUrlRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paths': value.paths,
    };
}

